// USD as the hotel boards print it: Latin «$46» (global constraint «USD shown
// as $46 Latin»), from the server's cents — display only, never a conversion.

/** 4600 → «$46»; 4650 → «$46.50». */
export function usdLatin(cents: number): string {
  const neg = cents < 0;
  const abs = Math.abs(cents);
  const whole = Math.floor(abs / 100);
  const rest = abs % 100;
  const body = rest === 0 ? String(whole) : `${whole}.${String(rest).padStart(2, '0')}`;
  return `${neg ? '-' : ''}$${body}`;
}
